import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia } from '../../components/imports';
// import CountUp from 'react-countup';
// import { Link } from 'react-router-dom';
// import useDisplayValue from '../../hooks/useDisplayValue';
// import useMouse from '../../hooks/useMouse';

const Content = () => {

  const heroRef = useRef(null);

  // const { formattingFn } = useDisplayValue("");
  // const { toDefault, toPlay } = useMouse();

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          <div className='DESK relative w-[100dvw] h-[200vh] items-start justify-start bg-black'>
            <div className='h-full flex startAll w-full'>
              <div className='block sticky top-0 mt-44 left-[10vw] inset-x-0 !w-1/2 !h-1/2 z-[2]'>
                <MotionContent imgRef={heroRef} height={"!h-[70vh]"} className="overflow-clip !w-fit">
                  {/*  <ImageMedia
              key={"heroJewoh"}
              src={require('./assets/Zara_TobaccoCollection_04.png')}
              className="relative md:landscape:scale-[120%] full object-cover object-bottom"
              /> */}
                  <video muted autoPlay loop src={require("./assets/r01_ZaraPerfume_1080x1350_.mp4")} className='relative scale-[102%] !h-[600px]'></video>
                </MotionContent>
              </div>

              <div className='absolute !right-0 z-[1] w-1/3 origin-top-right mr-[15%] flex flex-col pt-[20vh]'>
                <div className='relative flex flex-col max-h-[200vh]'>
                  <ImageMedia src={require("./assets/Zara Perfume (20x20cm)-02.png")} />
                  <ImageMedia src={require("./assets/Zara Perfume (20x20cm)-03.png")} />
                </div>
              </div>
            </div>

          </div>

          <div className='resp flex flex-row items-start justify-start w-full relative h-[200vh]'>
            {/* <div className='block bg-black relative h-full w-fit pb-16 paddingX'>
              <TextBox vertical
                padded resp className={"w-fit sticky top-0 pt-16 text-pretty"}
                title={"Iterate"}
                descr={<>
                </>}
              />
            </div> */}

            <div id="slidingContent" className='flex flex-col relative flex-grow lg:w-3/4 h-[200vh]'>
              <div className='bg-black w-full relative flex flex-col'>
                <div className='w-full padding items-center relative grid grid-cols-2'>
                  <ImageMedia src={require(`./assets/Zara_TobaccoCollection.jpg`)} className={"relative"} />
                  <ImageMedia src={require(`./assets/Zara_TobaccoCollection_02.jpg`)} className={"relative"} />
                </div>
              </div>
              <ImageMedia src={require(`./assets/Zara_TobaccoCollection_04.jpg`)} className={"relative h-screen object-contain w-full object-bottom"} />
            </div>

          </div>



        </div>
      )}
    </ThisProject>
  )
}

export default Content